/**
 * The uploaded logo (#152) for the current theme — light and dark variants both rendered, the
 * one for the other theme hidden by the `.dark` root class. A slot without its own variant uses
 * the other one; with no logo at all this renders nothing and the caller shows the app name.
 */
import type { MetaLogos } from '@/app/meta';
import { cn } from '@/lib/utils';

export function logoPair(logos: MetaLogos | undefined, kind: 'logomark' | 'lockup'): { light: string; dark: string } | null {
  const light = logos?.[`${kind}Light`] ?? null;
  const dark = logos?.[`${kind}Dark`] ?? null;
  if (!light && !dark) return null;
  return { light: (light ?? dark)!, dark: (dark ?? light)! };
}

export function BrandLogo({ logos, kind, appName, className }: { logos: MetaLogos | undefined; kind: 'logomark' | 'lockup'; appName: string; className?: string }) {
  const pair = logoPair(logos, kind);
  if (!pair) return null;
  return (
    <>
      <img src={pair.light} alt={`${appName} logo`} className={cn('[.dark_&]:hidden', className)} />
      <img src={pair.dark} alt={`${appName} logo`} className={cn('hidden [.dark_&]:block', className)} />
    </>
  );
}
